import { BaseEntity, DefaultResponseWithData } from "./system";
import { IVehicle } from "./Vehicle";

export interface ICheckIn extends BaseEntity {
  completed: string | null;
  completedBy: string | null;
  vehicleId: string;
  vehicle?: IVehicle;
  checkInItems?: ICheckInItem[];
}

export interface ICheckInStep extends BaseEntity {
  name: string;
  subtitle: string | null;
  order: number;
  needsValue: boolean;
  options: string | null;
  // A system step's field key (see ISystemStepField) - its answer is written onto the vehicle/lead.
  systemField?: string | null;
  needsImage: boolean;
  /** Documents on this step hold personal data — locked behind the v5c scope plus a PIN. */
  isSensitive: boolean;
  isActive: boolean;
}

export interface ICheckInItem extends BaseEntity {
  value: string | null;
  completed: string | null;
  completedBy: string | null;
  checkInStepId: string;
  checkInId: string;
  checkInStep?: ICheckInStep;
}

export interface ICreateCheckInRequest {
  vehicleId: string;
}

export interface ICreateUpdateCheckInItemRequest {
  vehicleId: string;
  checkInStepId: string;
  value?: string | null;
  isCompleted?: boolean;
}

export interface ICreateUpdateCheckInStepRequest {
  id?: string;
  name: string;
  subtitle: string | null;
  order: number;
  needsValue: boolean;
  options: string | null;
  // A system step's field key (see ISystemStepField) - its answer is written onto the vehicle/lead.
  systemField?: string | null;
  needsImage: boolean;
  isSensitive: boolean;
  isActive: boolean;
}

export enum SensitiveDocumentAccessOutcome {
  Granted,
  PinRejected,
}

export interface ISensitiveDocumentAccess {
  id: string;
  documentId: string;
  /** Read off the token when the row was written, so nullable in principle. */
  userId: string | null;
  accessedOn: string;
  /** Both null once the document has been deleted — they are resolved live, not stored. */
  stepName: string | null;
  fileName: string | null;
  outcome: SensitiveDocumentAccessOutcome;
}

export interface ISingleCheckInResponse extends DefaultResponseWithData<ICheckIn> {}
export interface ICheckInItemsResponse extends DefaultResponseWithData<ICheckInItem[]> {}
export interface ICheckInStepsResponse extends DefaultResponseWithData<ICheckInStep[]> {}
export interface ISingleCheckInItemResponse extends DefaultResponseWithData<ICheckInItem> {}
export interface ISingleCheckInStepResponse extends DefaultResponseWithData<ICheckInStep> {}
export interface ISensitiveDocumentAccessResponse extends DefaultResponseWithData<ISensitiveDocumentAccess[]> {}

export interface StartCheckInSessionRequest {
  checkInId: string;
}

export interface PauseCheckInSessionRequest {
  checkInId: string;
  userId: string;
  pauseReason: string;
}

export interface FinishCheckInSessionRequest {
  checkInId: string;
  userId: string;
}
